<template>
  <div class="app-container Srctwo5">
    <div class="left_pad">
      <div class="first_pad" style="height: 37%;z-index: 500;margin-bottom:1.5rem;margin: top 0!important;">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">巡查信息</span></div>
        <div class="box">
          <div style="width: 100%;height: 100%; z-index: 1000;" v-if="orderList.length>0">
            <info-list :data='orderList' type="巡查信息"></info-list>
          </div>
          <div class="no_data" v-else>
            <img src="../../assets/satistics/icon-no-order.png" alt="" class="no_data_img">
          </div>
          <div class="select_type">
            <div :class="[selectType1==0?'select_type_item selected':'select_type_item']" @click="changeType1(0)">近七天
            </div>
            <div :class="[selectType1==1?'select_type_item selected':'select_type_item']" @click="changeType1(1)">近一个月
            </div>
          </div>
        </div>
      </div>

      <div class="first_pad" style="height: 32%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">巡查占比分析</span></div>
        <div class="box" style="height: 75%;z-index: 1000;">
          <div class="two_pie">
            <div class="pie_item">
              <ec-pie type="细环无led" style="width: 100%;height: 100%" :data="pieData1" v-if="pieData1"
                      :color="pieColors"></ec-pie>
            </div>
            <div class="pie_item">
              <ec-pie type="细环无led" style="width: 100%;height: 100%" :data="pieData2" v-if="pieData2"
                      :color="pieColors"></ec-pie>
            </div>
          </div>
        </div>
      </div>

      <div class="first_pad" style="height:24%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">重点关注场所/企业</span></div>
        <div class="box" style="height: 63%;top: 3.5rem;">
          <div class="rate_table">
            <div class="table_item" style="color: white" v-if="analysisList.length>0">
              <div class="table_name">企业/场所名称</div>
              <div class="table_value">整改次数</div>
            </div>
            <el-carousel arrow="never"
                         direction="vertical"
                         style="height: 75%"
                         height="100%"
                         indicator-position="none"
                         :interval="3000"
                         v-if="analysisList.length>0"
                         autoplay
                         loop>
              <el-carousel-item v-for="(item,index) in analysisList">
                <div class="table_item" v-for="(item1,index1) in item">
                  <div class="table_name">{{item1.name}}</div>
                  <div class="table_value">{{item1.times}}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="no_data" v-else>
              <img src="../../assets/satistics/icon-no-order.png" alt="" style="width: 28%" class="no_data_img">
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="center_pad">
      <infoPad2 height="96" :title="chosenTitle" @change="changeTitle">
        <div class="inner_pad"
             style="position:absolute;z-index: 100;margin-top: 0.6rem;">
          <div class="inner_left" style="display: flex;align-items: center;justify-content: center">
            <img src="../../assets/map/bg3.png" style="width: 100%;height: 100%;position:absolute;z-index: 1"/>
            <ScreenMap
              ref="mapBox"
              style="position:absolute;z-index: 2;width: 94%;height: 94%;"
            />
          </div>
          <img src="../../assets/map/topBg.png" style="width: 100%;position:absolute;z-index: 3;top: -1.5rem;"/>
          <img src="../../assets/map/leftBg.png"
               style="height: 100%;position:absolute;z-index: 3;left:-1.5rem;top: 0;"/>
          <img src="../../assets/map/topBg.png" style="width: 100%;position:absolute;z-index: 3;bottom: -1.5rem;"/>
          <img src="../../assets/map/leftBg.png"
               style="height: 100%;position:absolute;z-index: 3;right:-1.5rem;top: 0;"/>
        </div>

      </infoPad2>
    </div>

    <div class="right_pad">
      <div class="first_pad" style="height: 47%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">告警工单</span></div>
        <div class="box">
          <div style="width: 100%;height: 100%; z-index: 1000;" v-if="warnList.length>0">
            <info-list :data='warnList' type="消防安全告警工单"></info-list>
          </div>
          <div class="no_data" v-else>
            <img src="../../assets/satistics/icon-no-order.png" style="width: 45%;" alt="" class="no_data_img">
          </div>
          <div class="select_type">
            <div :class="[selectType2==0?'select_type_item selected':'select_type_item']" @click="changeType2(0)">近七天
            </div>
            <div :class="[selectType2==1?'select_type_item selected':'select_type_item']" @click="changeType2(1)">近一个月
            </div>
          </div>
        </div>
      </div>

      <div class="first_pad" style="height: 48%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">视频监控</span></div>
        <div class="box">
          <div class="monitor_pad">
            <div class="monitor_line">
              <div class="monitor_item">
                <Video
                  id="myVideoPlayer1"
                  class="video-js video_pad monitor_item_img"
                  v-if="monitorUrl.length>0"
                  :autoplay="true"
                >
                </Video>
                <div class="no_data" v-else>
                  <img src="../../assets/satistics/icon-no-video.png" style="width: 65%" alt="" class="no_data_img">
                </div>
              </div>
              <div class="monitor_item">
                <Video
                  id="myVideoPlayer2"
                  class="video-js video_pad monitor_item_img"
                  v-if="monitorUrl.length>1"
                  :autoplay="true"
                >
                </Video>
                <div class="no_data" v-else>
                  <img src="../../assets/satistics/icon-no-video.png" style="width: 65%" alt="" class="no_data_img">
                </div>
              </div>
            </div>
            <div class="monitor_line">
              <div class="monitor_item">
                <Video
                  id="myVideoPlayer3"
                  class="video-js video_pad monitor_item_img"
                  v-if="monitorUrl.length>2"
                  :autoplay="true"
                >
                </Video>
                <div class="no_data" v-else>
                  <img src="../../assets/satistics/icon-no-video.png" style="width: 65%" alt="" class="no_data_img">
                </div>
              </div>
              <div class="monitor_item">
                <Video
                  id="myVideoPlayer4"
                  class="video-js video_pad monitor_item_img"
                  v-if="monitorUrl.length>3"
                  :autoplay="true"
                >
                </Video>

                <div class="no_data" v-else>
                  <img src="../../assets/satistics/icon-no-video.png" style="width: 65%" alt="" class="no_data_img">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Carousel, CarouselItem} from 'element-ui'
  import Vue from 'vue'
  import VideoJs from "video.js";

  Vue.use(Carousel)
  Vue.use(CarouselItem)

  function dateFormatter(year, month, date) {
    let monthStr = month > 9 ? month : '0' + month
    let dateStr = date > 9 ? date : '0' + date
    return year + '-' + monthStr + '-' + dateStr
  }

  import ScreenMap from "@/components/map/screenOperation"

  export default {
    name: "operation",
    components: {
      InfoPad: () => import('./components/infoPad.vue'),
      infoPad2: () => import('./components/infoPadNoTitle'),
      ecPie: () => import('./components/ec-pie'),
      infoList: () => import('./components/infolist'),
      ScreenMap,
    },
    data() {
      return {
        innerPic: 0,
        pieColors: ['#FFAD00', '#00B1FF', '#6F5AFF', '#00C16C', '#A893FF', '#59FFB6', '#FFD600', '#00D9FF'],
        chosenTitle: ['燃气数量', '烟感数量', '一键告警'],
        orderList: [
          // [
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          // ], [
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          // ], [
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          // ], [
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          //   {
          //     createdDate: '2022-07-06',
          //     typeName: '火点工单',
          //     content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
          //     statusName: '已处理'
          //   },
          // ],
        ],
        warnList: [
          [
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            }, {
            createdDate: '2022-07-06',
            type: '火点工单',
            content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
            statusName: '已处理'
          },
          ], [
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
          ], [

            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
            {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            }, {
              createdDate: '2022-07-06',
              type: '火点工单',
              content: '2022-07-06某摄像头监测点发现河2022-07-06某摄像头监测点发现河',
              statusName: '已处理'
            },
          ]],
        analysisList: [
          [
            {
              name: 'test1',
              value: 1
            }, {
            name: 'test1',
            value: 1
          }, {
            name: 'test1',
            value: 1
          },
          ], [
            {
              name: 'test1',
              value: 1
            }, {
              name: 'test1',
              value: 1
            }, {
              name: 'test1',
              value: 1
            },
          ], [
            {
              name: 'test1',
              value: 1
            }, {
              name: 'test1',
              value: 1
            }
          ],

        ],
        selectType1: 0,
        selectType2: 0,
        selectType3: 0,
        stoveNum: [0, 0, 0],
        smokeNum: [0, 0, 0],
        countDevice: [0, 0, 0],
        changeTitleNum: [0, 0, 0],
        pieData1: [{name: 'test1', value: 5}, {name: 'test2', value: 6}, {name: 'test3', value: 7}, {
          name: 'test4',
          value: 8
        }, {name: 'test5', value: 9},],
        pieData2: [{name: 'test1', value: 5}, {name: 'test1', value: 6}, {name: 'test1', value: 7}, {
          name: 'test1',
          value: 8
        }, {name: 'test1', value: 9},],
        monitorId: [ "6c0e1300055044a9ade06d3cc7ec1779", "dbb53d7d09dc482f8b85c43110e5a52d", "b201fe8d7e34483e9520ae87d8efe4af","f8da646ba6134ec7a842de98952842cc"],
        monitorUrl: [],
        monitorVideo1: null,
        monitorVideo2: null,
        monitorVideo3: null,
        monitorVideo4: null,
      }
    },
    created() {
      Promise.all([
        this.getcheckList(),
        this.getPlaceInfoList(),
        this.getWarnList(),
        this.getPieRate(),
        this.getStoveNum(),
        this.getSmokeNum(),
        this.getCountDevice(),
      ])

    },
    mounted() {
      Promise.all([
      // 1503ea22f31c43f1836b352eb722d1a5
        // this.getMonitorIds('dbb53d7d09dc482f8b85c43110e5a52d'),
      ])

      this.monitorId.forEach(item => {
        this.getMonitorUrl(item)
      })
      setTimeout(() => {
        console.log(this.monitorUrl,5555);
      },0)
      setTimeout(() => {
        this.monitorVideo1 = VideoJs("myVideoPlayer1");
        this.monitorVideo2 = VideoJs("myVideoPlayer2");
        this.monitorVideo3 = VideoJs("myVideoPlayer3");
        this.monitorVideo4 = VideoJs("myVideoPlayer4");
        this.initMonitorVideoController(this.monitorVideo1, this.monitorUrl[0].url);
        this.initMonitorVideoController(this.monitorVideo2, this.monitorUrl[1].url);
        this.initMonitorVideoController(this.monitorVideo3, this.monitorUrl[2].url);
        this.initMonitorVideoController(this.monitorVideo4, this.monitorUrl[3].url);
      }, 500)

      // this.monitorIntervalId = setInterval(() => {
      //   for (let i = 0; i < 4; i++) {
      //     let url = this.monitorUrl.shift()
      //     this.monitorUrl.push(url)
      //   }
      //   setTimeout(() => {
      //     this.initMonitorVideoController(this.monitorVideo1, this.monitorUrl[0]);
      //     this.initMonitorVideoController(this.monitorVideo2, this.monitorUrl[1]);
      //     this.initMonitorVideoController(this.monitorVideo3, this.monitorUrl[2]);
      //     this.initMonitorVideoController(this.monitorVideo4, this.monitorUrl[3]);
      //     this.monitorVideo1.load()
      //     this.monitorVideo2.load()
      //     this.monitorVideo3.load()
      //     this.monitorVideo4.load()
      //   }, 200)
      // }, 30000)

    },
    beforeDestroy() {
      this.monitorUrl = []
      clearInterval(this.monitorIntervalId)
      this.monitorIntervalId = null
      this.monitorVideo1.dispose()
      this.monitorVideo2.dispose()
      this.monitorVideo3.dispose()
      this.monitorVideo4.dispose()
    },
    methods: {
      getcheckList() {
        // 1 矛盾调解业务工单 2随手拍业务工单 0-1一键告警 0-2烟感 0-3燃气 0-4摄像头 0-4-1火点监测告警工单 0-4-2漂浮物监测告警工单 0-4-3不文明行为监测告警工单
        // let gdtype=['1','2','0-1','0-3','0-4','0-4-1','0-4-2','0-4-2','0-4-3']
        let gdtype = ['矛盾调解业务工单', '随手拍业务工单', '一键告警', '烟感', '燃气', '摄像头', '火点监测告警工单', '漂浮物监测告警工单', '不文明行为监测告警工单', '出租户巡查', '9+1场所巡查', '企业安全生产巡查']
        let gdtypecolor = ["#3467E7", "#0AAAAF", "#D8393B", "#52C41A", "#DB499E", "#886BA5", "#F18241", "#2DA6EA", "#9518E4", "rgba(50,101,225, 0.5)", "rgba(201,139,23, 0.5)", "rgba(26,169,78, 0.5)"]
        let intervalTime = this.selectType1 == 0 ? 7 * 24 * 3600000 : 30 * 24 * 3600000
        let now = new Date()
        let endTime = dateFormatter(now.getFullYear(), (now.getMonth() + 1), now.getDate())
        let start = new Date(now.getTime() - intervalTime)
        let startTime = dateFormatter(start.getFullYear(), (start.getMonth() + 1), start.getDate())
        let url = `api/threeScreen/pageCheck?currentPage=1&pageSize=50&startTime=${startTime}&endTime=${endTime}`
        let tmpArr = []
        let listArr = []
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            let {list} = res.data.data

            list.forEach((item, index) => {
              let items1 = item
              // console.log(item)
              let index1 = gdtype.findIndex(info => info === item.typeName);
              items1["ordercolorindex"] = gdtypecolor[index1]
              //       if (index % 3 == 0) {
              //         if (index != 0) {
              //           listArr.push(tmpArr)
              //         }
              // listArr.push(tmpArr)
              //         tmpArr = []
              //       }
              tmpArr.push(items1)
              if (index == list.length - 1 || index % 3 == 2) {
                listArr.push(tmpArr)
                tmpArr = []
              }

              // tmpArr.push(item)

              // console.log(tmpArr)
            })
            // console.log(listArr)
            this.orderList = JSON.parse(JSON.stringify(listArr))

          }
        })
      },
      getPlaceInfoList() {

        let intervalTime = this.selectType3 == 0 ? 7 * 24 * 3600000 : 30 * 24 * 3600000
        let now = new Date()
        let endTime = dateFormatter(now.getFullYear(), (now.getMonth() + 1), now.getDate())
        let start = new Date(now.getTime() - intervalTime)
        let startTime = dateFormatter(start.getFullYear(), (start.getMonth() + 1), start.getDate())
        let url = `api/threeScreen/timesCheck?currentPage=1&pageSize=50&startTime=${startTime}&endTime=${endTime}`
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            let {list} = res.data.data
            let tmpArr = []
            let listArr = []
            list.forEach((item, index) => {
              // if (index % 4 == 0) {
              //   if (index != 0) {
              //     listArr.push(tmpArr)
              //   }
              //   tmpArr = []
              // }
              tmpArr.push(item)
              if (index == list.length - 1 || index % 4 == 3) {
                listArr.push(tmpArr)
                tmpArr = []
              }

            })

            this.analysisList = listArr
          }
        })
      },
      getWarnList() {
        // 1 矛盾调解业务工单 2随手拍业务工单 0-1一键告警 0-2烟感 0-3燃气 0-4摄像头 0-4-1火点监测告警工单 0-4-2漂浮物监测告警工单 0-4-3不文明行为监测告警工单
        let gdtype = ['矛盾调解业务工单', '随手拍业务工单', '一键告警', '烟感', '燃气', '摄像头', '火点监测告警工单', '漂浮物监测告警工单', '不文明行为监测告警工单']
        // let gdtype=['1','2','0-1','0-3','0-4','0-4-1','0-4-2','0-4-2','0-4-3']
        let gdtypecolor = ["#3467E7", "#0AAAAF", "#D8393B", "#52C41A", "#DB499E", "#886BA5", "#F18241", "#2DA6EA", "#9518E4"]
        let intervalTime = this.selectType2 == 0 ? 7 * 24 * 3600000 : 92 * 24 * 3600000
        let now = new Date()
        let endTime = dateFormatter(now.getFullYear(), (now.getMonth() + 1), now.getDate())
        let start = new Date(now.getTime() - intervalTime)
        let startTime = dateFormatter(start.getFullYear(), (start.getMonth() + 1), start.getDate())
        let url = `api/threeScreen/pageWorkOrder?currentPage=1&pageSize=50&startTime=${startTime}&endTime=${endTime}`
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            let {list} = res.data.data
            let tmpArr = []
            let listArr = []
            list.forEach((item, index) => {
              let items1 = item
              let index1 = gdtype.findIndex(info => info === item.productTypeName);
              items1["ordercolorindex"] = gdtypecolor[index1]
              // if (index % 4 == 0) {
              //   if (index != 0) {
              //     listArr.push(tmpArr)
              //   }
              //   tmpArr = []
              // }
              // tmpArr.push(item)
              tmpArr.push(items1)
              if (index == list.length - 1 || index % 4 == 3) {
                listArr.push(tmpArr)
                tmpArr = []
              }
            })

            this.warnList = listArr
          }
        })
      },

      getMonitorIds(id) {
        this.$http.get(`api/hkDevice/page?&regionId=${id}&currentPage=1&pageSize=100`).then(res => {
          let list = res.data.data.list
          list.forEach(item => {
            this.monitorId.push(item.deviceId)
            this.getMonitorUrl(item.deviceId)
          })
        })
      },

      getPieRate() {
        this.$http.get('api/threeScreen/countCheck').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            this.pieData1 = [
              {name: '出租户巡查', value: data.selfHouse},
              {name: '9+1场所巡查', value: data.nineSmall},
              {name: '企业安全巡查', value: data.company},
            ];
            this.pieData2 = [
              {name: '已整改', value: data.rectify},
              {name: '需整改', value: data.needRectify},
            ];
          }
        })
      },
      getStoveNum() {
        this.$http.get('api/threeScreen/gas').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            this.stoveNum = [data.total, data.online, parseInt(data.offRate * 100)]
            this.changeTitleNum = this.stoveNum
          }
        })
      },
      getSmokeNum() {
        this.$http.get('api/threeScreen/smoke').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            this.smokeNum = [data.total, data.online, parseInt(data.offRate * 100)]
          }
        })
      },
      // 一键告警
      getCountDevice() {
        this.$http.get('api/threeScreen/countDevice?sourceType=40').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            let total = data.total === null ? '--' : data.total
            let online = data.online === null ? '--' : data.online
            let offRate = data.offRate === null ? '--' : parseInt(data.offRate * 100)
            this.countDevice = [total, online, offRate]
          }
        })
      },
      getMonitorUrl(id) {
        this.$http.post("api/hkDevice/requestHk", {
          url: "/api/video/v1/cameras/previewURLs",
          jsonObject: {
            cameraIndexCode: id,
            protocol: "hls",
            streamType: 1
          },
        }).then(res => {
          console.log(res.data.data);
          if (res.data.data && res.data.data.url) {
            let url = res.data.data.url
            if (process.env.NODE_ENV != 'development') {
              url = "https://lfczhxc.com/hk/" + res.data.data.url.substring(25);
            }
            if (url) {
              this.monitorUrl.push({url:url,id:id})
            }
          } else {
            // this.getMonitorIds('dbb53d7d09dc482f8b85c43110e5a52d')
          }
          // {url: 'http://121.228.250.36:83/openUrl/rAyA5pu/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAyRGxy/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAyRGxz/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAAzhjW/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rABZgYg/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAVRc4O/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAVRc4M/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAVzAWI/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAVRc4N/live.m3u8'},
          // {url: 'http://121.228.250.36:83/openUrl/rAZPzTG/live.m3u8'},
        })
        // console.log(this.monitorUrl, 333333333333);
      },

      initMonitorVideoController(minitorName, url) {
        minitorName.src([
          {
            type: "application/x-mpegURL",
            src: url,
          },
        ]);
      },

      changeType1(index) {
        this.selectType1 = index
        this.getcheckList()
      },
      changeType2(index) {
        this.selectType2 = index
        this.getWarnList()
      },
      changeType3(index) {
        this.selectType3 = index
        this.getPlaceInfoList()
      },
      changeTitle(index) {
        this.innerPic = index
        if (index == 0) {
          this.changeTitleNum = this.stoveNum
        } else if (index == 1) {
          this.changeTitleNum = this.smokeNum
        } else if (index == 2) {
          this.changeTitleNum = this.countDevice
        }


      },
    }
  }
</script>

<style scoped lang="less">
  .first_pad {
    position: relative;
    width: 100%;
    margin: 1.8rem 0;

    .pad_title {
      position: absolute;
      left: 5%;
      top: 5%;
      font-size: 20px;
      color: rgba(73, 169, 255, 1);
      user-select: none;

      .pad_title_text {
        margin: 0 0.8rem;
        cursor: pointer;
      }

      .selected_title {
        font-size: 26px;
        color: #FFFFFF;
        font-family: myTitle;
      }
    }

    .content_area {
      position: absolute;
      top: 15%;
      left: 50%;
      transform: translate(-50%, 0);
      width: 90%;
      height: 80%;


    }

    .top_right {
      position: absolute;
      right: 5%;
      top: 6%;
    }

    .more_button {
      font-size: 14px;
      color: rgba(0, 247, 255, 1);
      user-select: none;
      cursor: pointer;
    }


    .back_img {
      width: 100%;
      height: 100%;
    }

    .circle_img {
      position: absolute;
      left: 15.5%;
      top: 55%;
      transform: translate(0, -50%);
      width: 40%;
    }

    .gd_list_item {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      margin: 0.6rem 0.4rem;
      padding: 0.8rem 0.5rem 0.3rem 0.5rem;
      background: rgba(4, 49, 110, 0.4);
      box-sizing: border-box;
      cursor: pointer;

      .gd_list_item_line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        box-sizing: border-box;

        .gd_list_item_type {
          width: 60%;
          // padding: 4px;
          color: #ffffff;
          // text-align: center;
          span {
            background: rgba(50, 101, 225, 0.5);
            border-radius: 5px;
            color: #ffffff;
            padding: 0.2rem 0.4rem;
          }

          // border: 1px solid rgba(49, 206, 255, 1);
          // color: rgba(49, 206, 255, 1);
        }

        .gd_list_item_time {
          color: #ffffff;
          text-align: right;
        }
      }

      .gd_list_item_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;

        .gd_list_item_title {
          // width:100%;
          text-align: left;
          color: white;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 3;
          // -webkit-box-orient: vertical;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }

        .gd_list_item_status {
          font-size: 14px;
          width: 60px;
          text-align: right;
        }
      }
    }
  }

  .box {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    height: 80%;
    width: 88%;
  }

  .app-container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .left_pad {
      position: absolute;
      top: 8%;
      left: 0;
      padding: 1.2rem 1rem 2rem 1.5rem;
      height: 92%;
      width: 30%;

      ::v-deep {
        .el-carousel__item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

        }
      }

      .rate_table {
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: #00C0FF;
        padding: 0 0.4rem;

        ::v-deep {
          .el-carousel {
            height: 75%;
          }

          .el-carousel__item {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;

            .table_item:nth-child(even) {
              background: rgba(0, 0, 0, 0);
            }

            .table_item:nth-child(odd) {
              /*background: red;*/
              background: rgba(7, 22, 41, 0.4)
            }
          }
        }

        .table_item {
          display: flex;
          height: 33%;
          justify-content: space-between;
          align-items: center;
          padding: 0.4rem 0.4rem;

          .table_name {
            flex: 1;
            text-align: left;
          }

          .table_value {
            width: 60px;
            text-align: center;
          }
        }

      }

      .select_type {
        position: absolute;
        top: calc(-0.4rem - 48px);
        right: 0.6rem;
        width: 30%;
        height: 44px;
        display: flex;
        align-items: center;
        color: #fff;
        z-index: 550;

        .select_type_item {
          flex: 1;
          height: 100%;
          font-size: 16px;
          line-height: 44px;
          text-align: center;
          cursor: pointer;
        }

        .selected {
          background: linear-gradient(to bottom, rgba(48, 101, 201, 0) 0%, rgba(48, 101, 201, 0.7100) 100%);
          border-width: 0 0 3px 0;
          border-style: solid;
          border-color: rgba(0, 174, 255, 1);
        }
      }


      .two_pie {
        width: 100%;
        height: 100%;
        display: flex;

        .pie_item {
          width: 50%;
          height: 100%;

          &:last-child {
            width: 50%;
          }
        }
      }

      .list_item {
        height: 25%;
        padding: 0.1rem 0.4rem;


        .list_item_line {
          color: white;
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 0.4rem;

          .list_item_type {
            margin-left: 0.8rem;
            padding: 0.2rem 0.4rem;
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 4px;
            color: rgba(226, 156, 63, 1);
          }
        }

        .list_item_content {
          color: white;;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          line-height: 28px;

          .list_item_title {
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .list_item:nth-child(odd) {
        background: rgba(4, 49, 110, 0.2);
      }

      .list_item:nth-child(even) {
        background: rgba(7, 22, 41, 0.3);
      }

    }

    .center_pad {
      position: absolute;
      left: 30%;
      top: 10%;
      padding: 0 1.5rem 2rem 1rem;
      height: 90%;
      width: 40%;

      .inner_pad {
        width: 100%;
        height: 100%;
        display: flex;
      }

      .inner_left {
        height: 100%;
        width: 100%;
        /*background: green;*/

        .inner_left_icon {
          width: 100%;
          height: 100%;
        }
      }

      .inner_left_top {
        position: absolute;
        left: 0;
        top: 0;

        .inner_line1 {
          background: rgba(29, 76, 153, 0.2);
          display: flex;
          align-items: center;
          color: #fff;
          padding: 0 1rem;
          height: 6.5rem;
          margin-bottom: 1rem;
          position: relative;
          width: 15rem;

          .inner_line1_icon {
            width: 40%;

            .line1_icon_img {
              width: 4.5rem;
              margin-right: 2rem;
            }
          }

          .inner_line1_text {
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;
          }

          .inner_line1_num {
            font-family: myDigib;
            font-size: 42px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 42px;
          }
        }


      }

      .inner_right_top {
        position: absolute;
        right: 0;
        top: 0;

        .inner_line2 {
          width: 100%;
          height: calc(100% - 7.5rem);

          .inner_line2_content {
            height: 135px;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .inner_line2_item {
              background: rgba(29, 76, 153, 0.2);
              /*border: 2px solid #0E223D;*/
              display: flex;
              align-items: center;
              padding: 0.4rem 0.8rem;
              color: #fff;

              .inner_line2_item_icon {
                width: 16%;

                .item_icon_img {
                  width: 100%;
                }
              }

              .inner_line2_item_text {
                flex: 1;
                padding: 0 0.3rem;
                font-size: 16px;
              }

              .inner_line2_item_num {
                padding: 0 0.5rem;
                font-family: myDigib;
                font-size: 32px;
                font-weight: 600;
              }

              .more_img {
                width: 14px;
              }
            }
          }
        }

      }
    }

    .right_pad {
      position: absolute;
      right: 0;
      top: 8%;
      padding: 0 1.5rem 2rem 1rem;
      height: 92%;
      width: 30%;


      .list_item {
        height: 20%;
        padding: 0.4rem 0.4rem;

        .list_item_line {
          color: white;
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 0.4rem;

          .list_item_type {
            margin-left: 0.8rem;
            padding: 0.2rem 0.4rem;
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 4px;
            color: rgba(226, 156, 63, 1);
          }
        }


        .list_item_content {
          color: white;;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          line-height: 28px;

          .list_item_title {
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .list_item:nth-child(odd) {
        background: rgba(4, 49, 110, 0.2);
      }

      .list_item:nth-child(even) {
        background: rgba(7, 22, 41, 0.3);
      }

      ::v-deep {
        .el-carousel__item {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
      }

      .monitor_pad {
        width: 100%;
        height: 100%;

        .monitor_line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 48%;
          margin-bottom: 0.4rem;

          .monitor_item {
            width: 49%;
            height: 100%;

            .monitor_item_img {
              width: 100%;
              height: 100%;
            }
          }
        }

      }

      .select_type {
        position: absolute;
        top: calc(-0.4rem - 48px);
        right: 0.6rem;
        width: 30%;
        height: 44px;
        display: flex;
        align-items: center;
        color: #fff;
        z-index: 550;

        .select_type_item {
          flex: 1;
          height: 100%;
          font-size: 16px;
          line-height: 44px;
          text-align: center;
          cursor: pointer;
        }

        .selected {
          background: linear-gradient(to bottom, rgba(48, 101, 201, 0) 0%, rgba(48, 101, 201, 0.7100) 100%);
          border-width: 0 0 3px 0;
          border-style: solid;
          border-color: rgba(0, 174, 255, 1);
        }
      }
    }

    .no_data {
      position: relative;
      width: 100%;
      height: 100%;
      background: rgba(35, 55, 91, 0.4500);

      .no_data_img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 42%;
      }
    }

  }
</style>
